import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../components/Login";
import MessageChat from "../components/MessageChat";
import VideoChat from "../components/VideoChat";
import WhiteBoard from "@/components/WhiteBoard.vue";

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: Login
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/message-chat",
    name: "MessageChat",
    component: MessageChat
  },
  {
    path: "/video-chat",
    name: "VideoChat",
    component: VideoChat
  },
  {
    path: "/whiteBoard",
    name: "WhiteBoard",
    component: WhiteBoard,
    props: true
  }
]

const router = new VueRouter({
  routes
})

export default router
